import script from "./AIChatGroupedSandwichesRenderer.vue?vue&type=script&lang=ts&setup=true"
export * from "./AIChatGroupedSandwichesRenderer.vue?vue&type=script&lang=ts&setup=true"

import "./AIChatGroupedSandwichesRenderer.vue?vue&type=style&index=0&id=4cd57144&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd57144"]])

export default __exports__